import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import { useSelector } from 'react-redux';
import GetField from '../Components/GetField';
import styles from '../styles';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;

const ItemForm = props => {
  const { classes, control, itemIndex, itemRemove, itemAppend } = props;

  const unitIds = useSelector(state => state.unitIds);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].name`}
          control={control}
          render={({ field }) => (
            <AntInput placeholder="Item" size="small" {...field} />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].shade`}
          control={control}
          render={({ field }) => (
            <AntInput placeholder="Shade" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].size`}
          control={control}
          render={({ field }) => (
            <AntInput placeholder="Size" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].unitId`}
          control={control}
          render={({ field }) => (
            <AntSelect placeholder="Select unit" {...field}>
              {unitIds.map(unit => (
                <Option key={unit.id} value={unit.id}>
                  {unit.unit}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].quantity`}
          control={control}
          render={({ field }) => (
            <AntInput
              placeholder="Quantity"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].remark`}
          control={control}
          render={({ field }) => (
            <AntInput placeholder="Remark" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined onClick={() => itemRemove(itemIndex)} />
        &nbsp; &nbsp;
        <PlusCircleOutlined onClick={() => itemAppend({})} />
      </td>
    </tr>
  );
};

ItemForm.propTypes = {
  classes: PropTypes.object.isRequired,
  control: PropTypes.any.isRequired,
  itemAppend: PropTypes.func.isRequired,
  itemRemove: PropTypes.func.isRequired,
  itemItem: PropTypes.object.isRequired,
  itemIndex: PropTypes.number.isRequired,
};

export default withStyles(styles)(ItemForm);
